var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { staticClass: "header" },
    [
      _c("a", { staticClass: "logo cursor-pointer", attrs: { href: "/" } }, [
        _c("img", {
          attrs: {
            src: require("../../../../static/imgs/exhibition/logo.png"),
            alt: "logo",
          },
        }),
      ]),
      _c("lang", { staticClass: "login-header" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }